import React, { Component } from 'react'
import moment from "moment";

class DateData {
  
    selectedmonth= moment().format('YYYY-MM');
    pageNavigate=false;
    item = {startDate: '',endDate:'',pagenav:false,idcontroll:''}

    setdate(stdate,enddate,pagenav,idcontroll) {     
      this.item.startDate = stdate;
      this.item.endDate = enddate;
      this.item.pagenav=pagenav
      this.item.idcontroll=idcontroll
      // console.log(this.item,"-----------------");
    }  

    setSelectedDate(date){
      this.selectedmonth=date;
    }
    setpageNav(pagenav){
        this.pageNavigate=pagenav;
      }
      setIdcontrol(idcontroll){
        this.idcontroll=idcontroll;
      }
}
export default new DateData();
